import { getSubscriberRating } from '@/shared/utils';

export default {
  methods: {
    getQuery() {
      const maxRating = getSubscriberRating(this.subscriber.dateOfBirth);
      let query = '';
      const sort = this.sort || this.category?.defaultSortField;
      const order = this.order || this.category?.defaultSortOrder;

      if (this.maxResults !== undefined) {
        query += `&maxResults=${this.maxResults}`;
      }

      if (this.category) {
        query += `&categoryId[]=${this.category.id}`;
      }

      if (sort) {
        query += `&sort=${sort}`;
      }

      if (order) {
        query += `&order=${order}`;
      }

      if (this.filter) {
        query += `&vodFilter[]=${this.filter}`;
      }

      if (this.firstResult !== undefined) {
        query += `&firstResult=${this.firstResult}`;
      }

      if (maxRating) {
        query += `&maxRating=${maxRating}`;
      }

      return query;
    },
  },
};
